import { PhoneCall, ClipboardList, Puzzle, HeartHandshake } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

const STEPS = [
  {
    icon: PhoneCall,
    num: "01",
    title: "Free Discovery Call",
    desc: "A relaxed 15-minute chat to understand what you or your child needs — no pressure, no commitment.",
  },
  {
    icon: ClipboardList,
    num: "02",
    title: "Gentle Intake Session",
    desc: "We explore history, strengths and goals together. For children, this happens through play, not questionnaires.",
  },
  {
    icon: Puzzle,
    num: "03",
    title: "Personalised Therapy Plan",
    desc: "A plan shaped around you — play therapy for children; CBT, client-centred therapy and conflict management for teens, adults and families.",
  },
  {
    icon: HeartHandshake,
    num: "04",
    title: "Growth & Ongoing Support",
    desc: "Regular sessions, parent guidance and between-session support, so progress keeps growing at home too.",
  },
];

export default function Process() {
  return (
    <section id="process" data-testid="how-it-works-section" className="bg-[#F7F4EB] py-20 lg:py-28">
      <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
        <Reveal className="mb-12 max-w-2xl lg:mb-16">
          <Eyebrow>How it works</Eyebrow>
          <h2 className="mt-4 font-serif text-3xl font-medium leading-snug tracking-tight text-[#064E3B] sm:text-4xl lg:text-5xl">
            Beginning is the <em className="text-[#059669]">bravest</em> step — I make it easy
          </h2>
        </Reveal>
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4 lg:gap-8">
          {STEPS.map((step, i) => (
            <Reveal key={step.num} delay={i * 0.1}>
              <div
                data-testid="process-step-item"
                className="group relative h-full rounded-3xl border border-[#064E3B]/12 bg-[#FFFDF9] p-7 transition-transform duration-300 hover:-translate-y-1.5 hover:shadow-[0_18px_40px_-18px_rgba(6,78,59,0.3)]"
              >
                <div className="flex items-start justify-between">
                  <span className="flex h-11 w-11 items-center justify-center rounded-2xl bg-[#ECFDF5] text-[#064E3B]">
                    <step.icon size={22} />
                  </span>
                  <span className="font-serif text-5xl font-light text-[#064E3B]/15 transition-colors duration-300 group-hover:text-[#D97706]/40">
                    {step.num}
                  </span>
                </div>
                <h3 className="mt-5 font-serif text-xl font-medium text-[#064E3B] sm:text-2xl">{step.title}</h3>
                <p className="mt-2.5 text-sm leading-relaxed text-[#526560]">{step.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
